import React from 'react'
import { ShareIcon, CrossIcon } from 'assets/icons'
import './AddToHomeScreen.scss'

interface State {
    show: boolean
}

const browser: any = navigator

export default class AddToHomeScreen extends React.Component<Object, State> {

    constructor(props: Object) {
        super(props)
        this.state = {
            show: false,
        }
    }

    public componentDidMount() {
        if (('standalone' in browser) && !browser.standalone) {
            this.setState({
                show: true
            })
        }
    }

    public handleClose = () => {
        this.setState({
            show: false
        })
    }

    public render() {
        return(
            <React.Fragment>
                {this.state.show &&
                    <div id="add-to-homescreen">
                        <div className="content u-flex u-flex-row">
                            <img src="logo_compact.png" alt="Florensis surplus"/>
                            <div>
                                <h3>Florensis Surplus</h3>
                                <p>
                                    Install this app on your phone. Tab
                                    <ShareIcon width={15} height={15} />
                                    <br/>
                                    then 'Add to homescreen'.
                                </p>
                            </div>
                            <button className="close" onClick={this.handleClose}>
                                <CrossIcon stroke="#000"/>
                            </button>
                        </div>
                    </div>}
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/AddToHomeScreen/index.tsx